<template>
  <section class="about">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="col-top">
            100+
          </div>
          <div class="col-middle">
            <span>Реализованные проекты</span>
          </div>
          <div class="col-bottom">
            Работаем с любой недвижимостью – от дворцов до квартир
          </div>
        </div>
        <div class="col">
          <div class="col-top">
            10 лет
          </div>
          <div class="col-middle">
            Безупречная репутация
          </div>
          <div class="col-bottom">
            Наши специалисты постоянно стажируются у лидеров строительных работ
          </div>
        </div>
        <div class="col">
          <div class="col-top">
            3 года
          </div>
          <div class="col-middle">
            Гарантии на все работы
          </div>
          <div class="col-bottom">
            Мы внимательно изучаем рынок отделочных материалов и инновационной техники
          </div>
        </div>
        <div class="col">
          <div class="col-top">
            Сроки
          </div>
          <div class="col-middle">
            Процесс
          </div>
          <div class="col-bottom">
            Нужно лучшее – закажи это у лучших!
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionAbout',
  components: {
  },
  methods: {
  },
  computed: {
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.about {
  background-color: #eee;
  padding: 45px 0;
  @media (max-width: 1199.98px) {
    padding: 45px 0 25px 0;
  }
  @media (max-width: 575.98px) {
    padding: 20px 0 0 0;
  }
  .row {
    background-color: #eaeaea;
    padding: 30px 30px;
    display: flex;
    margin: 0 -30px;
    @media (max-width: 1199.98px) {
      flex-wrap: wrap;
    }
    @media (max-width: 575.98px) {
      margin: 0;
    }
    .col {
      flex: 1 1 25%;
      max-width: 25%;
      padding: 0 20px;
      box-sizing: border-box;
      @media (max-width: 1199.98px) {
        flex: 1 1 50%;
        max-width: 50%;
        margin-bottom: 20px;
      }
      @media (max-width: 575.98px) {
        flex: 1 1 100%;
        max-width: 100%;
        padding: 0;
      }
      &-top {
        font-size: 3.6rem;
        color: #0E0E0E;
      }
      &-middle {
        margin-top: 10px;
        font-size: 2.2rem;
        color: #0E0E0E;
        padding-left: 17px;
        position: relative;
        &:before {
          position: absolute;
          content: '';
          top: 5px;
          left: 0;
          width: 10px;
          height: 10px;
          background-color: #0E0E0E;
        }
      }
      &-bottom {
        padding-left: 17px;
        margin-top: 16px;
        font-weight: 300;
        font-size: 1.4rem;
        color: #0E0E0E;
      }
    }
  }
}
</style>
